// Datei: src/editorjs/CodeBlock.js

// 1) Prism-CSS (Dark Theme) importieren
import "prismjs/themes/prism-tomorrow.css";

// 2) PrismJS selbst importieren
import Prism from "prismjs";

// 3) Nur die Sprach-Module importieren, die du wirklich brauchst (Namen müssen exakt stimmen!)
import "prismjs/components/prism-javascript";
import "prismjs/components/prism-markup"; // für HTML
import "prismjs/components/prism-css";
import "prismjs/components/prism-python";
import "prismjs/components/prism-bash";
import "prismjs/components/prism-swift";
import "prismjs/components/prism-java";
import "prismjs/components/prism-wiki";
import "prismjs/components/prism-sql";

export default class CodeBlock {
  constructor({ data }) {
    // data kommt von Editor.js oder ist neu: { code: "", language: "javascript" }
    this.data = data || { code: "", language: "javascript" };
    this.wrapper = null;
    this.langSelect = null;
    this.textarea = null;
    this.preContainer = null;
  }

  render() {
    // 1) Erstelle den Haupt-Wrapper
    this.wrapper = document.createElement("div");
    this.wrapper.classList.add("code-block-wrapper", "mb-4");

    // 2) <select> für die Sprachauswahl
    this.langSelect = document.createElement("select");
    ["javascript", "html", "css", "python", "bash", "swift", "java","wiki", "sql", ].forEach(
      (lang) => {
        const option = document.createElement("option");
        option.value = lang;
        option.textContent = lang;
        if (lang === this.data.language) option.selected = true;
        this.langSelect.appendChild(option);
      }
    );
    this.langSelect.classList.add(
      "w-full",
      "border",
      "rounded",
      "p-1",
      "mb-2",
      "bg-gray-800",
      "text-slate-50",
      "text-xs"
    );
    this.langSelect.addEventListener("change", (e) => {
      this.data.language = e.target.value;
      this._updateHighlightedCode(); // neu färben, sobald Sprache wechselt
    });
    this.wrapper.appendChild(this.langSelect);

    // 3) <textarea> für den Rohcode
    this.textarea = document.createElement("textarea");
    this.textarea.placeholder = "// Dein Code hier…";
    this.textarea.value = this.data.code;
    this.textarea.className =
      "w-full border rounded p-2 font-mono text-sm  bg-[#151515] text-slate-50 min-h-[100px] mb-2";
    this.textarea.addEventListener("input", (e) => {
      this.data.code = e.target.value;
      this._updateHighlightedCode(); // neu färben, sobald Inhalt geändert
    });
    this.wrapper.appendChild(this.textarea);

    // 4) <pre><code> für Prism Highlighting
    this.preContainer = document.createElement("pre");
    this.preContainer.classList.add(
      "rounded",
      "overflow-auto",
      "text-sm",
      "p-4",
      " bg-[#151515]",
      "text-slate-50",
      "font-mono"
    );
    const codeTag = document.createElement("code");
    codeTag.classList.add(`language-${this.data.language}`);
    codeTag.textContent = this.data.code || "// dein Code erscheint hier";
    this.preContainer.appendChild(codeTag);
    this.wrapper.appendChild(this.preContainer);

    // 5) Einmalig initial highlighten
    this._updateHighlightedCode();

    return this.wrapper;
  }

  _updateHighlightedCode() {
    if (!this.preContainer) return;
    const codeTag = this.preContainer.querySelector("code");
    if (!codeTag) return;

    // a) Klasse (Sprache) neu setzen
    codeTag.className = "";
    codeTag.classList.add(`language-${this.data.language}`);

    // b) Inhalt neu setzen
    codeTag.textContent = this.data.code;

    // c) Prism färbt das <code>‐Element neu
    Prism.highlightElement(codeTag);
  }

  save() {
    // Editor.js erwartet hier das JSON‐Objekt, das gespeichert wird.
    return this.data;
  }

  static get toolbox() {
    return {
      title: "Code",
      icon: "💻",
    };
  }
}
